import "./art_card.scss";

import { Icon } from "@components/icon";
import { ImageUnavailable } from "@components/image_unavailable/image_unvailable";
import * as types from "@root/types";
import { backgroundImageStyle } from "@services/background_image.service";
import { noop } from "@services/helpers";
import cx from "classnames";
import React, { FC } from "react";

interface ArtCardProps {
  artPiece: types.ArtPiece;
  classes?: string | string[];
  onClick?: () => void;
  withExpandIcon?: boolean;
}

const ArtCard: FC<ArtCardProps> = ({
  artPiece,
  classes,
  onClick,
  withExpandIcon,
}) => {
  const handleClick = onClick
    ? (e: { preventDefault: () => void }) => {
        e.preventDefault();
        onClick();
      }
    : noop;

  if (!artPiece.imageUrls?.large) {
    return <ImageUnavailable />;
  }

  const imageStyle = backgroundImageStyle(artPiece.imageUrls.large);
  const artPieceImageLabel = `${artPiece.title} by ${artPiece.artistName}`;

  return (
    <div className={cx("art-card", classes)}>
      {withExpandIcon ? (
        <div className="art-card--expand-icon">
          <Icon ariaLabel="Expand" name="enlarge" />
        </div>
      ) : null}
      <a
        href="#"
        onClick={handleClick}
        title={artPiece.title}
        aria-label={artPiece.title}
      >
        <div
          className="art-card--image"
          style={imageStyle}
          role="img"
          aria-label={artPieceImageLabel}
        />
      </a>
    </div>
  );
};

export { ArtCard, ArtCardProps };
